<form id="filter" data-cy="filter-mobile-form" [formGroup]="filtersFormGroup">
  <div data-cy="filter-mobile-modal" class="modal-top"></div>
  <ion-content id="content-window" [scrollY]="false">
    <div class="filter-container" data-cy="filter-mobile-container">
      <div *ngIf="!selectedFilter" class="filter-title">
        <ion-label data-cy="filter-mobile-title" translate>{{
          'i18n.search.searchResultsPage.sortAndFilter'
        }}</ion-label>
        <div *ngIf="numberOfSelectedFilters?.total" class="filter-number-pill">
          <span data-cy="filter-mobile-number-pill">
            {{ numberOfSelectedFilters?.total }}
          </span>
        </div>
      </div>
      <div
        *ngIf="
          !!selectedFilter && selectedFilter?.refinementType === 'SortOptions'
        "
        class="filter-title"
      >
        <ion-icon
          data-cy="filter-mobile-back-icon"
          name="chevron-back-outline"
          (click)="setSelectedFilter(null)"
        ></ion-icon>
        <ion-label data-cy="filter-mobile-search-results-order" translate>{{
          'i18n.search.searchResultsPage.searchResultsOrder'
        }}</ion-label>
      </div>
      <div
        *ngIf="
          !!selectedFilter && selectedFilter?.refinementType !== 'SortOptions'
        "
        class="filter-title"
      >
        <ion-icon
          data-cy="filter-mobile-back-icon"
          name="chevron-back-outline"
          (click)="setSelectedFilter(null)"
        ></ion-icon>
        <ion-label
          [attr.data-cy]="
            'filter-mobile-filter-' +
            selectedFilter?.displayName +
            '-label-name'
          "
          >{{ selectedFilter?.displayName }}</ion-label
        >
      </div>

      <div class="filter-content">
        <div class="filters" *ngIf="!selectedFilter">
          <div class="filter-options">
            <ng-container *ngIf="showSort">
              <h2
                class="filter-header"
                data-cy="filter-mobile-title-sort-by"
                translate
              >
                {{ 'i18n.common.sortBy' }}
              </h2>
              <ion-item
                detail
                [class.selected]="
                  selectedFilter === searchViewModel?.searchResponse.sortOptions
                "
                data-cy="filter-mobile-item-sort-by"
                (click)="
                  setSelectedFilter({
                    refinementType: 'SortOptions',
                    sortOptions: searchViewModel?.searchResponse.sortOptions,
                  })
                "
              >
                <div class="label-wrapper">
                  <ion-label
                    class="filter-option"
                    data-cy="filter-mobile-label-search-results-order"
                    translate
                  >
                    {{ 'i18n.search.searchResultsPage.searchResultsOrder' }}
                  </ion-label>
                  <div
                    class="selected-filters-number"
                    data-cy="filter-mobile-sort-label"
                    *ngIf="!!numberOfSelectedFilters?.sortLabel"
                  >
                    {{ numberOfSelectedFilters?.sortLabel }}
                  </div>
                </div>
              </ion-item>
            </ng-container>
            <h2
              class="filter-header"
              data-cy="filter-mobile-title-filter-by"
              translate
            >
              {{ 'i18n.common.filterBy' }}
            </h2>

            <ng-container
              *ngFor="
                let navigation of searchViewModel?.searchResponse.navigation;
                let i = index
              "
            >
              <ion-item
                *ngIf="
                  navigation.refinements && navigation.refinements.length > 0
                "
                [attr.data-cy]="'filter-mobile-' + i + '-item'"
                detail
                [class.selected]="selectedFilter === navigation"
                (click)="setSelectedFilter(navigation)"
              >
                <div class="label-wrapper">
                  <ion-label
                    class="filter-option"
                    [attr.data-cy]="'filter-mobile-' + i + '-label-name'"
                  >
                    {{ navigation.displayName }}
                  </ion-label>
                  <div
                    class="selected-filters-number"
                    *ngIf="!!numberOfSelectedFilters[navigation.displayName]"
                  >
                    {{ numberOfSelectedFilters[navigation.displayName] }}
                    <span
                      [attr.data-cy]="'filter-mobile-' + i + '-selected'"
                      *ngIf="
                        isNumber(
                          numberOfSelectedFilters[navigation.displayName]
                        )
                      "
                      >{{ 'i18n.orderStatusPage.selected' | translate }}</span
                    >
                  </div>
                </div>
              </ion-item>
            </ng-container>
          </div>
        </div>

        <div class="filters-details" *ngIf="!!selectedFilter">
          <div class="filter-input" data-cy="filter-mobile-input">
            <!-- Sort Options -->
            <div
              class="radio-group filter-item"
              *ngIf="selectedFilter?.refinementType === 'SortOptions'"
              formGroupName="sortOptions"
            >
              <ion-list>
                <ion-radio-group
                  class="filter-radio"
                  data-cy="filter-mobile-radio-group"
                  formControlName="sortOption"
                >
                  <ng-container
                    *ngFor="
                      let sortOption of selectedFilter.sortOptions;
                      let i = index
                    "
                  >
                    <ion-item>
                      <div class="item-content">
                        <ion-label
                          ><span
                            [attr.data-cy]="'filter-mobile-' + i + '-label'"
                            >{{ sortOption.label }}</span
                          ></ion-label
                        >
                        <ion-radio
                          mode="md"
                          [attr.data-cy]="'filter-mobile-' + i + '-radio'"
                          value="{{ sortOption.navigationState }}"
                        ></ion-radio>
                      </div>
                    </ion-item>
                  </ng-container>
                </ion-radio-group>
              </ion-list>
            </div>
            <!-- MultiSelect Refinements -->
            <div
              class="check-box filter-item"
              [ngClass]="{
                scroll: selectedFilter?.displayName === 'Allergens',
              }"
              *ngIf="
                selectedFilter?.refinementType === 'RefinementMenu' &&
                selectedFilter?.refinements?.length &&
                selectedFilter?.refinements[0]?.multiSelect === true
              "
              data-cy="filter-mobile-multi-refinements-checkbox"
              formGroupName="multiRefinements"
            >
              <ion-list [formGroupName]="selectedFilter.filterName">
                <ng-container
                  *ngFor="let refinement of filterRefinements; let i = index"
                >
                  <ion-item>
                    <div class="item-content">
                      <ion-label class="item-label">
                        <img
                          *ngIf="
                            selectedFilter.filterName === 'Product Ratings'
                          "
                          class="star-ratings-image"
                          [src]="getImageUrl(refinement)"
                        />
                        <span
                          [attr.data-cy]="
                            'filter-mobile-multi-refinements-' + i + '-label'
                          "
                          >{{ refinement.displayName }}
                        </span>
                        <span class="count"> ({{ refinement.count }}) </span>
                      </ion-label>
                      <ion-checkbox
                        mode="ios"
                        [attr.data-cy]="
                          'filter-mobile-multi-refinements-' + i + '-checkbox'
                        "
                        [formControlName]="refinement.dimensionId"
                        (ionChange)="clickCheckBox(refinement, false)"
                      ></ion-checkbox>
                    </div>
                  </ion-item>
                </ng-container>
              </ion-list>
            </div>
            <!-- Single Select Refinements -->
            <div
              *ngFor="
                let navigation of searchViewModel?.searchResponse.navigation;
                let i = index
              "
            >
              <div
                class="radio-group filter-item"
                *ngIf="
                  selectedFilter?.displayName === navigation.displayName &&
                  !!selectedFilter?.refinements?.length &&
                  selectedFilter?.refinements[0]?.multiSelect === false
                "
                data-cy="filter-mobile-single-refinements"
                formGroupName="singleRefinements"
              >
                <ion-list [formGroupName]="selectedFilter.filterName">
                  <ion-radio-group
                    [name]="selectedFilter.displayName"
                    class="filter-radio"
                    [attr.data-cy]="
                      'filter-mobile-single-refinements-' + i + '-radio-group'
                    "
                    [formControlName]="selectedFilter.displayName"
                    allow-empty-selection="true"
                  >
                    <ng-container
                      *ngFor="
                        let refinement of selectedFilter.refinements;
                        let x = index
                      "
                    >
                      <ion-item>
                        <div class="item-content">
                          <ion-label>
                            <span
                              [attr.data-cy]="
                                'filter-mobile-single-refinements-' +
                                i +
                                '-' +
                                x +
                                '-label'
                              "
                              >{{ refinement.displayName }}</span
                            >
                          </ion-label>
                          <span>({{ refinement.count }})</span>
                          <div class="item-content-radio">
                            <ion-radio
                              mode="md"
                              [attr.data-cy]="
                                'filter-mobile-single-refinements-' +
                                i +
                                '-' +
                                x +
                                '-radio-value'
                              "
                              [value]="refinement.dimensionId"
                              (click)="clickCheckBox(refinement, true)"
                            ></ion-radio>
                          </div>
                        </div>
                      </ion-item>
                    </ng-container>
                  </ion-radio-group>
                </ion-list>
              </div>
            </div>
            <!-- Range Refinements -->
            <div
              class="range-refinement filter-item"
              data-cy="filter-mobile-range-refinements"
              *ngIf="selectedFilter?.refinementType === 'RangeRefinementMenu'"
              formGroupName="rangeRefinements"
            >
              <ion-list [formGroupName]="selectedFilter.displayName">
                <ng-container
                  *ngFor="
                    let refinement of rangeWithUOMRefinements;
                    let i = index
                  "
                >
                  <ion-item
                    [attr.data-cy]="
                      'filter-mobile-range-refinements-' + i + '-item'
                    "
                    [formGroupName]="refinement.dimesionName"
                  >
                    <div class="item-content">
                      <div class="range-label">
                        <span
                          [attr.data-cy]="
                            'filter-mobile-range-refinements-' + i + '-label'
                          "
                          >{{ refinement.displayName }}</span
                        >
                      </div>
                      <div class="item-input">
                        <ion-input
                          inputmode="decimal"
                          [attr.data-cy]="
                            'filter-mobile-range-refinements-' +
                            i +
                            '-input-min-value'
                          "
                          [placeholder]="refinement.minVal"
                          decimal
                          formControlName="minVal"
                        ></ion-input>
                        <span class="range-to-label">to</span>
                        <ion-input
                          inputmode="decimal"
                          [attr.data-cy]="
                            'filter-mobile-range-refinements-' +
                            i +
                            '-input-max-value'
                          "
                          [placeholder]="refinement.maxVal"
                          decimal
                          formControlName="maxVal"
                        ></ion-input>
                        <span
                          [attr.data-cy]="
                            'filter-mobile-range-refinements-' +
                            i +
                            '-label-uom'
                          "
                          class="input-label"
                          >{{ refinement.uom }}</span
                        >
                      </div>
                    </div>
                  </ion-item>
                </ng-container>
              </ion-list>
            </div>
          </div>
        </div>
      </div>

      <div
        class="disclaimer-text"
        data-cy="filter-mobile-disclaimer-text"
        *ngIf="selectedFilter?.displayName === 'Allergens'"
      >
        <section
          [innerHTML]="'i18n.search.searchFilters.important' | translate"
        ></section>
      </div>
    </div>
  </ion-content>
  <ion-content [scrollY]="false">
    <div data-cy="filter-mobile-footer" class="modal-footer">
      <ion-button
        class="filter-button usf-outline-green-mobile-modal-button"
        data-cy="filter-mobile-button-clear-all"
        translate
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' }}
      </ion-button>

      <ion-button
        class="filter-button usf-fill-green-mobile-modal-button"
        data-cy="filter-mobile-button-apply"
        translate
        (click)="apply()"
      >
        {{ 'i18n.common.apply' }}
      </ion-button>
    </div>
  </ion-content>
</form>
